import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { changeFormField, setFieldError, setNewForm, updateFormProperties } from 'apps/auth/actions/formAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Text } from 'apps/auth/components/common/Text/Text';
import InputSMS from 'apps/auth/components/form/InputSMS';
import Form from 'apps/auth/components/form-multi/Form';
import { smsConfirmationToFields } from 'apps/auth/components/form-multi/utils';
import Spinner from 'apps/auth/components/utils/Spinner/Spinner';
import { SMS_CONFIRMATION_FORM_NAME } from 'apps/auth/constants/formName';
import { apiFetchData } from 'apps/auth/helpers/api';
import update from 'immutability-helper';

const SEND_SMS = '/ga/sms/send.action';

const RESET_INTERVAL = 59;

class SmsConfirmation extends React.Component {
    constructor(props) {
        super(props);

        this.timerID = null;
        this.submitRef = React.createRef();

        this.state = {
            resetInterval: RESET_INTERVAL,
            showResend: false,
        };

        this.submitHandler = this.submitHandler.bind(this);
        this.resendClick = this.resendClick.bind(this);
    }

    componentDidMount() {
        apiFetchData(SEND_SMS).then((json) => {
            this.props.setNewForm(SMS_CONFIRMATION_FORM_NAME, smsConfirmationToFields(json.extra?.smsConfirmation, '#'));
            if (json.errors) {
                Object.keys(json.errors).forEach((name) => {
                    this.props.setFieldError(SMS_CONFIRMATION_FORM_NAME, name, json.errors[name]);
                });
            }
            this.tick();
        });
    }

    componentWillUnmount() {
        clearInterval(this.timerID);
    }

    componentDidUpdate(props) {
        if (props.forms[SMS_CONFIRMATION_FORM_NAME] && this.props.forms[SMS_CONFIRMATION_FORM_NAME]) {
            let currentCode = this.props.forms[SMS_CONFIRMATION_FORM_NAME].fields.code.value;
            let previousCode = props.forms[SMS_CONFIRMATION_FORM_NAME].fields.code.value;
            if (currentCode && currentCode.length === 5 && currentCode !== previousCode) {
                this.submitRef.current.click();
            }
        }
    }

    submitHandler(fields, json) {
        if (json && json.errors) {
            Object.keys(json.errors).forEach((name) => {
                this.props.setFieldError(SMS_CONFIRMATION_FORM_NAME, name, json.errors[name]);
            });
        }

        if (json && json.extra.card?.showPin) {
            this.props.setShowModal?.();
        }

        this.props.updateFormProperties(SMS_CONFIRMATION_FORM_NAME, this.props.confirmURL);
    }

    tick() {
        if (this.timerID) {
            clearInterval(this.timerID);
        }
        this.timerID = setInterval(() => {
            const distance = this.state.resetInterval - 1;
            const seconds = distance >= 10 ? distance : '0' + distance;
            this.setState(
                update(this.state, {
                    resetInterval: { $set: seconds },
                }),
            );
            if (distance < 0) {
                clearInterval(this.timerID);
                //show resend
                this.setState(
                    update(this.state, {
                        showResend: { $set: true },
                    }),
                );
            }
        }, 1000);
    }

    clearErrorAndValue(oldField) {
        const newFieldCode = update(oldField, {
            value: { $set: null },
            isError: { $set: false },
            errorMessage: { $set: null },
        });
        this.props.changeFormField(SMS_CONFIRMATION_FORM_NAME, newFieldCode);
    }

    resendClick(e) {
        e.preventDefault();
        new Promise((resolve) => {
            this.setState(
                update(this.state, {
                    resetInterval: { $set: RESET_INTERVAL },
                    showResend: { $set: false },
                }),
            );
            const { value, isError } = this.props.forms[SMS_CONFIRMATION_FORM_NAME].fields.code;
            if (value || isError) {
                const fieldCode = this.props.forms[SMS_CONFIRMATION_FORM_NAME].fields.code;
                this.clearErrorAndValue(fieldCode);
            }

            this.props.updateFormProperties(SMS_CONFIRMATION_FORM_NAME, SEND_SMS).then(() => {
                this.submitRef.current.click();
                resolve(true);
            });
        }).then((resolve) => {
            if (resolve) {
                this.setState(
                    update(this.state, {
                        action: { $set: this.props.confirmURL },
                    }),
                );
                this.tick();
            }
        });
    }

    render() {
        if (!this.props.forms[SMS_CONFIRMATION_FORM_NAME]) {
            return <Spinner forceShow={true} />;
        }
        const fields = this.props.forms[SMS_CONFIRMATION_FORM_NAME].fields;
        return (
            <>
                <HeaderPanel title={this.props.enterSmsTitle} subtitle={this.props.sentSms} />
                <Form formName={SMS_CONFIRMATION_FORM_NAME} field={fields} onSubmitHandler={this.submitHandler} action={this.props.confirmURL}>
                    <Row indent="24px">
                        <InputSMS field={fields.code} formName={SMS_CONFIRMATION_FORM_NAME} focus={true} isNewInput isSmsInput />
                    </Row>
                    {this.state.showResend && (
                        <Row flex justify="center">
                            <Button variant="secondary" onClick={(e) => this.resendClick(e)} caption={this.props.smsResendBtn} id="resend_sms_link" />
                        </Row>
                    )}
                    {!this.state.showResend && (
                        <Text size="secondary" color="lightGray">
                            {this.props.smsResendTitle} {`00:${this.state.resetInterval}`}
                        </Text>
                    )}
                    <Button type="submit" variant={'hidden'} ref={this.submitRef} />
                </Form>
            </>
        );
    }
}

SmsConfirmation.propTypes = {
    redirectUrl: PropTypes.string,
    termsOfUseCode: PropTypes.string,
    setShowModal: PropTypes.func,
};

const mapStateToProps = (state) => {
    return {
        forms: state.form,
        termsOfUseCode: state.messages.pageMessages.termsOfUseCode,
        enterSmsTitle: state.messages.pageMessages.enterSmsTitle,
        smsResendBtn: state.messages.pageMessages.smsResendBtn,
        smsResendTitle: state.messages.pageMessages.smsResendTitle,
        sentSms: state.messages.pageMessages.sentSms,
    };
};
export default connect(mapStateToProps, {
    setNewForm,
    setFieldError,
    updateFormProperties,
    changeFormField,
})(SmsConfirmation);
